import React from 'react'

const StudentsIcon = ({ color = '#3249D7' }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.85 20.525C6.95 19.875 5.98767 19.35 4.963 18.95C3.93767 18.55 2.86667 18.275 1.75 18.125C1.25 18.0583 0.833333 17.8457 0.5 17.487C0.166667 17.129 0 16.7167 0 16.25V9.2C0 8.56667 0.216667 8.04567 0.65 7.637C1.08333 7.229 1.59167 7.075 2.175 7.175C3.45833 7.39167 4.67933 7.78333 5.838 8.35C6.996 8.91667 8.05 9.65 9 10.55C9.95 9.65 11.0043 8.91667 12.163 8.35C13.321 7.78333 14.5417 7.39167 15.825 7.175C16.4083 7.075 16.9167 7.229 17.35 7.637C17.7833 8.04567 18 8.56667 18 9.2V16.25C18 16.7167 17.8333 17.129 17.5 17.487C17.1667 17.8457 16.75 18.0583 16.25 18.125C15.1333 18.275 14.0627 18.55 13.038 18.95C12.0127 19.35 11.05 19.875 10.15 20.525C9.81667 20.775 9.43333 20.9 9 20.9C8.56667 20.9 8.18333 20.775 7.85 20.525ZM9 8C7.9 8 6.95833 7.60833 6.175 6.825C5.39167 6.04167 5 5.1 5 4C5 2.9 5.39167 1.95833 6.175 1.175C6.95833 0.391667 7.9 0 9 0C10.1 0 11.0417 0.391667 11.825 1.175C12.6083 1.95833 13 2.9 13 4C13 5.1 12.6083 6.04167 11.825 6.825C11.0417 7.60833 10.1 8 9 8Z"
      fill={color}
    />
  </svg>
)

export default StudentsIcon
